import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'app-sidebar-developers',
  templateUrl: './sidebar-developers.component.html',
  styleUrls: ['./sidebar-developers.component.sass']
})
export class SidebarDevelopersComponent implements OnInit {
  authenticated$: any;
  hasIntegration: false;

  constructor(
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.authenticated$ = this.authService.getAuthenticatedUser();
    this.checkIntegration();
  }

  hasScope(scope) {
    return this.authService.hasScope(scope);
  }

  checkIntegration() {
    this.authenticated$.subscribe((response) => {
      if (response) {
        const configuration = response.program?.configuration;

        if (configuration) {
          this.hasIntegration =  configuration.has_awin;
        }
      }
    });
  }
}
